import Api from "../apiService";

class CargoUnitsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/cargo/units`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/cargo/units/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/cargo/units`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/units/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/units/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/cargo/units/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }
}

export default new CargoUnitsApi();
